msgid ""
msgstr ""
"POT-Creation-Date: 2025-06-26 16:26-0600\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/clients/signed-in/program-app/components/ProgramCompletion.tsx:117
msgid "{completedSkills} of {totalSkills} skills completed. Keep going!"
msgstr "{completedSkills} of {totalSkills} skills completed. Keep going!"

#. js-lingui-explicit-id
#: src/clients/signed-in/program-app/components/CompetencyExercises.tsx:100
msgid "number.of.steps"
msgstr "{exerciseCount} {exerciseCount, plural, one {step} other {steps}}"

#: src/clients/signed-in/program-app/tools/exercise.tsx:168
msgid ""
"{message}\n"
"\n"
"Please try again."
msgstr ""
"{message}\n"
"\n"
"Please try again."

#: src/clients/signed-in/program-app/tools/competencies.tsx:68
msgid "{progressIndex} of {competencyMaxIndex} completed"
msgstr "{progressIndex} of {competencyMaxIndex} completed"

#. js-lingui-explicit-id
#: src/clients/signed-in/program-app/tools/review.tsx:168
#: src/clients/signed-in/program-app/tools/results.tsx:141
#: src/clients/signed-in/program-app/components/CompetencyExercises.tsx:94
msgid "number.of.minutes"
msgstr "{timeEstimate} {timeEstimate, plural, one {minute} other {minutes}}"

#: src/clients/signed-in/program-app/ProgramBySlug.tsx:215
msgid "~{totalMinutes} min"
msgstr "~{totalMinutes} min"

#: src/clients/signed-in/program-app/components/nps-survey/NpsStep.tsx:21
#: src/clients/signed-in/program-app/components/nps-survey/NpsStep.tsx:36
msgid "0 - Not at all likely"
msgstr "0 - Not at all likely"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:192
msgid "1-99 employees"
msgstr "1-99 employees"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:195
msgid "1,000-2,499 employees"
msgstr "1,000-2,499 employees"

#: src/clients/signed-in/program-app/components/nps-survey/NpsStep.tsx:39
msgid "10 - Extremely likely"
msgstr "10 - Extremely likely"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:198
msgid "10,000+ employees"
msgstr "10,000+ employees"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:193
msgid "100-499 employees"
msgstr "100-499 employees"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:196
msgid "2,500-4,999 employees"
msgstr "2,500-4,999 employees"

#: src/clients/signed-in/program-app/tools/overview.tsx:89
msgid "3 min"
msgstr "3 min"

#: src/clients/signed-in/program-app/tools/overview.tsx:79
msgid "30 min"
msgstr "30 min"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:197
msgid "5,000-9,999 employees"
msgstr "5,000-9,999 employees"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:194
msgid "500-999 employees"
msgstr "500-999 employees"

#: src/clients/signed-in/components/NewVersionAvailable.tsx:24
msgid "A new version of ProfAI is available."
msgstr "A new version of ProfAI is available."

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:204
msgid "Accounting/Finance"
msgstr "Accounting/Finance"

#: src/clients/signed-in/components/UserAvatarMenu.tsx:31
msgid "Admin Panel"
msgstr "Admin Panel"

#: src/clients/signed-in/program-app/components/AiHallucinationPracticeExercise.tsx:63
msgid "AI OUTPUT"
msgstr "AI OUTPUT"

#: src/clients/signed-in/program-app/components/onboarding/Profile.tsx:134
msgid "Analyzing"
msgstr "Analyzing"

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:473
msgid "And ends with \"<0>{lastWord}</0>\""
msgstr "And ends with \"<0>{lastWord}</0>\""

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:180
msgid "Associate/Staff"
msgstr "Associate/Staff"

#: src/clients/signed-in/reporting-app/NpsReport.tsx:261
msgid "Average Confidence"
msgstr "Average Confidence"

#: src/clients/signed-in/reporting-app/NpsReport.tsx:273
msgid "Average Overall"
msgstr "Average Overall"

#: src/clients/signed-in/program-app/components/StartScreen.tsx:20
msgid "Back"
msgstr "Back"

#: src/clients/signed-in/program-app/ProfilePage.tsx:168
msgid "Back to app"
msgstr "Back to app"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:289
msgid "Back to exercises"
msgstr "Back to exercises"

#: src/clients/signed-in/program-app/tools/results.tsx:79
msgid "Back to Program Skills"
msgstr "Back to Program Skills"

#: src/clients/signed-in/program-app/components/StdFlowMessageAckExercise.tsx:77
#: src/clients/signed-in/program-app/components/PromptTypesContentExercise.tsx:68
#: src/clients/signed-in/program-app/components/PromptMadLibExercise.tsx:158
#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:336
#: src/clients/signed-in/program-app/components/AiPrivacyPracticeExercise.tsx:45
#: src/clients/signed-in/program-app/components/AiPrivacyExamplesExercise.tsx:82
#: src/clients/signed-in/program-app/components/AiBiasPracticeExercise.tsx:131
msgid "Back to skill"
msgstr "Back to skill"

#: src/clients/signed-in/program-app/tools/review.tsx:110
msgid "Back to Skill Overview"
msgstr "Back to Skill Overview"

#: src/clients/signed-in/program-app/tools/competencies.tsx:57
msgid "Back to Skills"
msgstr "Back to Skills"

#: src/clients/signed-in/components/analytics-dashboard/UserEngagementChart.tsx:38
#: src/clients/signed-in/components/analytics-dashboard/MetricsGrid.tsx:41
msgid "Badges Earned"
msgstr "Badges Earned"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:217
msgid "Banking"
msgstr "Banking"

#: src/clients/signed-in/program-app/components/PromptTypesExercise.tsx:63
#: src/clients/signed-in/program-app/components/PromptTypesContentExercise.tsx:13
msgid "Basic"
msgstr "Basic"

#: src/clients/signed-in/program-app/Programs.tsx:13
msgid "Basic AI Proficiency"
msgstr "Basic AI Proficiency"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:20
msgid "basic prompt"
msgstr "basic prompt"

#: src/clients/signed-in/program-app/tools/profile.tsx:74
msgid "Before we dive in, let's learn a bit about you so that I can tailor the content to you and your role."
msgstr "Before we dive in, let's learn a bit about you so that I can tailor the content to you and your role."

#: src/clients/signed-in/components/TutorAvatar.tsx:52
msgid "BETA"
msgstr "BETA"

#: src/clients/signed-in/program-app/components/AiBiasPracticeExercise.tsx:64
msgid "Bias Sources"
msgstr "Bias Sources"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:444
#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:135
#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:141
#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:195
#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:201
#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:216
msgid "Boundaries"
msgstr "Boundaries"

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:71
msgid "Boundaries define the limits or constraints of the task. Look for phrases that specify what should be maintained, avoided, or kept within certain parameters."
msgstr "Boundaries define the limits or constraints of the task. Look for phrases that specify what should be maintained, avoided, or kept within certain parameters."

#: src/clients/signed-in/program-app/tools/overview.tsx:73
msgid "Build your prompting skills with interactive exercises."
msgstr "Build your prompting skills with interactive exercises."

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:185
msgid "C-Suite (ie. COO, CIO, CTO, CHRO)"
msgstr "C-Suite (ie. COO, CIO, CTO, CHRO)"

#: src/clients/signed-in/program-app/components/ProgramBadge.tsx:46
msgid "Check {email} or click the badge here to open it in Credly."
msgstr "Check {email} or click the badge here to open it in Credly."

#: src/clients/signed-in/program-app/components/AiUseCasePromptBuilderExercise.tsx:166
msgid "Check my idea"
msgstr "Check my idea"

#: src/clients/signed-in/program-app/tools/overview.tsx:67
msgid "Choose the best starting point based on your experience level"
msgstr "Choose the best starting point based on your experience level"

#: src/clients/signed-in/program-app/components/onboarding/Language.tsx:26
msgid "Choose your language"
msgstr "Choose your language"

#: src/clients/signed-in/program-app/components/ProgramCompletion.tsx:125
msgid "Claim"
msgstr "Claim"

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:422
msgid "Click on the word where {currentStepLabel} begins"
msgstr "Click on the word where {currentStepLabel} begins"

#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:253
msgid "Click the button to reveal the {breakdownNextStep}."
msgstr "Click the button to reveal the {breakdownNextStep}."

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:42
#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:46
msgid "Company Name"
msgstr "Company Name"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:85
msgid "Company Size"
msgstr "Company Size"

#: src/clients/signed-in/program-app/ProgramBySlug.tsx:105
msgid "Complete these skills to unlock your badge—perfect to showcase on LinkedIn or your portfolio."
msgstr "Complete these skills to unlock your badge—perfect to showcase on LinkedIn or your portfolio."

#: src/clients/signed-in/program-app/components/PromptTypesExercise.tsx:81
#: src/clients/signed-in/program-app/components/PromptTypesContentExercise.tsx:15
msgid "Comprehensive"
msgstr "Comprehensive"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:22
msgid "comprehensive prompt"
msgstr "comprehensive prompt"

#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:114
msgid "Comprehensive prompts include the role, task description, context, and specific requirements. They also include the boundaries and reasoning. Boundaries define what the AI should avoid and ensure its outputs are unbiased. Reasoning enhances the AI response to explain its thinking process, not just providing conclusions."
msgstr "Comprehensive prompts include the role, task description, context, and specific requirements. They also include the boundaries and reasoning. Boundaries define what the AI should avoid and ensure its outputs are unbiased. Reasoning enhances the AI response to explain its thinking process, not just providing conclusions."

#: src/clients/signed-in/program-app/components/ProgramBadge.tsx:36
msgid "Congrats on the {programTitle} badge!"
msgstr "Congrats on the {programTitle} badge!"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:186
msgid "Consultant"
msgstr "Consultant"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:218
msgid "Consulting"
msgstr "Consulting"

#: src/clients/signed-in/components/UserAvatarMenu.tsx:24
msgid "Content Catalog"
msgstr "Content Catalog"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:427
#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:132
#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:138
#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:192
#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:198
#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:212
msgid "Context"
msgstr "Context"

#: src/clients/signed-in/program-app/ProgramBySlug.tsx:217
#: src/clients/signed-in/program-app/tools/overview.tsx:128
#: src/clients/signed-in/program-app/components/StdFlowMessageAckExercise.tsx:78
#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:289
#: src/clients/signed-in/program-app/components/PromptMadLibExercise.tsx:159
#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:336
#: src/clients/signed-in/program-app/components/CustomerVideoExercise.tsx:69
#: src/clients/signed-in/program-app/components/CompetencyExercises.tsx:214
#: src/clients/signed-in/program-app/components/AiPrivacyPracticeExercise.tsx:46
msgid "Continue"
msgstr "Continue"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:277
msgid "Continue to next exercise"
msgstr "Continue to next exercise"

#: src/clients/signed-in/program-app/components/AIAcademyLink.tsx:15
msgid "Continue your AI learning journey on AI Academy"
msgstr "Continue your AI learning journey on AI Academy"

#: src/clients/signed-in/components/analytics-dashboard/UserEngagementChart.tsx:170
msgid "Converted"
msgstr "Converted"

#: src/clients/signed-in/program-app/components/AiUseCasePromptBuilderExercise.tsx:248
msgid "Copied!"
msgstr "Copied!"

#: src/clients/signed-in/program-app/components/AiUseCasePromptBuilderExercise.tsx:252
msgid "Copy"
msgstr "Copy"

#: src/clients/signed-in/program-app/tools/planning.tsx:137
msgid "Creating your personalized exercise now."
msgstr "Creating your personalized exercise now."

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:212
msgid "Customer Support/Success"
msgstr "Customer Support/Success"

#: src/clients/signed-in/components/PromoDialog.tsx:82
msgid "Customizable to your policies and priorities"
msgstr "Customizable to your policies and priorities"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:208
msgid "Data/Analytics"
msgstr "Data/Analytics"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:183
msgid "Department head"
msgstr "Department head"

#: src/clients/signed-in/program-app/tools/planning.tsx:138
msgid "Designing a custom exercise specifically for you."
msgstr "Designing a custom exercise specifically for you."

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:182
msgid "Director"
msgstr "Director"

#: src/clients/signed-in/program-app/components/PromptTypesExercise.tsx:55
msgid "Does a Basic, Focused, or Comprehensive prompt type suit this scenario best?"
msgstr "Does a Basic, Focused, or Comprehensive prompt type suit this scenario best?"

#: src/clients/signed-in/program-app/components/AiUseCasePromptBuilderExercise.tsx:268
msgid "Download"
msgstr "Download"

#: src/clients/signed-in/program-app/components/PdfDownload.tsx:17
msgid "Download PDF"
msgstr "Download PDF"

#: src/clients/signed-in/program-app/components/PdfDownload.tsx:13
msgid "Download the AI Proficiency Cheat Sheet for future reference"
msgstr "Download the AI Proficiency Cheat Sheet for future reference"

#: src/clients/signed-in/components/analytics-dashboard/DashboardHeader.tsx:74
#: src/clients/signed-in/components/analytics-dashboard/DashboardHeader.tsx:83
msgid "Download User Data"
msgstr "Download User Data"

#: src/clients/signed-in/components/analytics-dashboard/DashboardHeader.tsx:72
#: src/clients/signed-in/components/analytics-dashboard/DashboardHeader.tsx:81
msgid "Downloading..."
msgstr "Downloading..."

#: src/clients/signed-in/program-app/components/ExerciseHelp.tsx:250
#: src/clients/signed-in/program-app/components/onboarding/Profile.tsx:77
msgid "e.g. Educational startup using AI for personalized tutoring"
msgstr "e.g. Educational startup using AI for personalized tutoring"

#: src/clients/signed-in/program-app/components/ExerciseHelp.tsx:263
#: src/clients/signed-in/program-app/components/onboarding/Profile.tsx:110
msgid "e.g. Senior UX Designer creating AI-driven course flows"
msgstr "e.g. Senior UX Designer creating AI-driven course flows"

#: src/clients/signed-in/program-app/components/ExerciseHelp.tsx:71
msgid "Edit Customizations"
msgstr "Edit Customizations"

#: src/clients/signed-in/program-app/components/AiPrivacyPracticeExercise.tsx:110
msgid "Edit PROMPT"
msgstr "Edit PROMPT"

#: src/clients/signed-in/program-app/components/AiUseCasePromptBuilderExercise.tsx:124
msgid "Edit Prompt Idea"
msgstr "Edit Prompt Idea"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:203
msgid "Engineering/IT"
msgstr "Engineering/IT"

#: src/clients/signed-in/components/analytics-dashboard/UserEngagementChart.tsx:14
msgid "Enrolled"
msgstr "Enrolled"

#: src/clients/signed-in/program-app/components/PromptMadLibExercise.tsx:23
msgid "Enter the boundaries..."
msgstr "Enter the boundaries..."

#: src/clients/signed-in/program-app/components/PromptMadLibExercise.tsx:21
msgid "Enter the context..."
msgstr "Enter the context..."

#: src/clients/signed-in/program-app/components/PromptMadLibExercise.tsx:24
msgid "Enter the reasoning..."
msgstr "Enter the reasoning..."

#: src/clients/signed-in/program-app/components/PromptMadLibExercise.tsx:22
msgid "Enter the requirements..."
msgstr "Enter the requirements..."

#: src/clients/signed-in/program-app/components/PromptMadLibExercise.tsx:19
msgid "Enter the role..."
msgstr "Enter the role..."

#: src/clients/signed-in/program-app/components/PromptMadLibExercise.tsx:20
msgid "Enter the task..."
msgstr "Enter the task..."

#: src/clients/signed-in/program-app/tools/profile.tsx:144
msgid "Enter your company name..."
msgstr "Enter your company name..."

#: src/clients/signed-in/program-app/tools/profile.tsx:88
msgid "Enter your name"
msgstr "Enter your name"

#: src/clients/signed-in/program-app/tools/profile.tsx:194
msgid "Enter your role and responsibilities..."
msgstr "Enter your role and responsibilities..."

#: src/clients/signed-in/components/PromoDialog.tsx:78
msgid "Enterprise reporting and analytics"
msgstr "Enterprise reporting and analytics"

#: src/clients/signed-in/program-app/ProgramSkill.tsx:50
msgid "Error loading content data"
msgstr "Error loading content data"

#: src/clients/signed-in/reporting-app/ProgressReport.tsx:28
msgid "Error loading data"
msgstr "Error loading data"

#: src/clients/signed-in/reporting-app/NpsReport.tsx:52
msgid "Error loading NPS data"
msgstr "Error loading NPS data"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:184
msgid "EVP, VP"
msgstr "EVP, VP"

#: src/clients/signed-in/program-app/components/StdFlowMessageAckExercise.tsx:52
msgid "example"
msgstr "example"

#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:263
msgid "example prompt"
msgstr "example prompt"

#: src/clients/signed-in/program-app/components/nps-survey/ExperienceStep.tsx:33
msgid "Excellent"
msgstr "Excellent"

#: src/clients/signed-in/program-app/components/CompetencyExercises.tsx:111
msgid "Exercises"
msgstr "Exercises"

#: src/clients/signed-in/program-app/components/StdFlowMessageAckExercise.tsx:80
msgid "Explain"
msgstr "Explain"

#: src/clients/signed-in/program-app/components/nps-survey/ConfidenceStep.tsx:34
msgid "Extremely confident"
msgstr "Extremely confident"

#: src/clients/signed-in/program-app/components/AiHallucinationPracticeExercise.tsx:27
msgid "Fabricated Fact"
msgstr "Fabricated Fact"

#: src/clients/signed-in/program-app/components/AiHallucinationPracticeExercise.tsx:28
msgid "Fabricated Source"
msgstr "Fabricated Source"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:404
msgid "FEEDBACK"
msgstr "FEEDBACK"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:219
msgid "Finance"
msgstr "Finance"

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:281
msgid "Find the <0>{stepLabel}</0> by clicking and dragging over the phrase in the text below."
msgstr "Find the <0>{stepLabel}</0> by clicking and dragging over the phrase in the text below."

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:273
msgid "Find the <0>{stepLabel}</0> by clicking the first and last words of the phrase in the text below."
msgstr "Find the <0>{stepLabel}</0> by clicking the first and last words of the phrase in the text below."

#: src/clients/signed-in/program-app/components/onboarding/Profile.tsx:134
msgid "Finish"
msgstr "Finish"

#: src/clients/signed-in/program-app/tools/results.tsx:118
msgid "Finish Up"
msgstr "Finish Up"

#: src/clients/signed-in/program-app/components/Onboarding.tsx:69
msgid "Finishing up..."
msgstr "Finishing up..."

#: src/clients/signed-in/program-app/components/ExerciseHelp.tsx:220
#: src/clients/signed-in/program-app/components/BadgeDialog.tsx:84
#: src/clients/signed-in/program-app/components/onboarding/User.tsx:27
msgid "First Name"
msgstr "First Name"

#: src/clients/signed-in/program-app/components/BadgeDialog.tsx:91
msgid "First name is required"
msgstr "First name is required"

#: src/clients/signed-in/program-app/components/AiPrivacyExamplesExercise.tsx:40
#: src/clients/signed-in/program-app/components/AiPrivacyExamplesExercise.tsx:68
msgid "Fix it up!"
msgstr "Fix it up!"

#: src/clients/signed-in/program-app/components/AiPrivacyPracticeExercise.tsx:92
msgid "Fix the sensitive information in the prompt below by anonymizing them."
msgstr "Fix the sensitive information in the prompt below by anonymizing them."

#: src/clients/signed-in/program-app/components/PromptTypesExercise.tsx:72
#: src/clients/signed-in/program-app/components/PromptTypesContentExercise.tsx:14
msgid "Focused"
msgstr "Focused"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:21
msgid "focused prompt"
msgstr "focused prompt"

#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:60
msgid ""
"Focused prompts build on the task description and context in basic prompts by adding a role and specific requirements. \n"
"\n"
"Below is a focused prompt that has a role and specific requirements. Start by clicking the button below to reveal the Role."
msgstr ""
"Focused prompts build on the task description and context in basic prompts by adding a role and specific requirements. \n"
"\n"
"Below is a focused prompt that has a role and specific requirements. Start by clicking the button below to reveal the Role."

#: src/clients/signed-in/program-app/components/AiUseCasePromptBuilderExercise.tsx:186
msgid "Generate Prompt template"
msgstr "Generate Prompt template"

#: src/clients/signed-in/program-app/components/ExerciseHelp.tsx:182
msgid "Generating content..."
msgstr "Generating content..."

#: src/clients/signed-in/program-app/components/BadgeDialog.tsx:108
msgid "GET MY BADGE"
msgstr "GET MY BADGE"

#: src/clients/signed-in/components/PromoBanner.tsx:23
msgid "Get your whole team AI-Certified."
msgstr "Get your whole team AI-Certified."

#: src/clients/signed-in/components/PromoDialog.tsx:57
msgid "Get your whole<0/> team <1>AI-certified</1><2/> with ProfAI for Teams"
msgstr "Get your whole<0/> team <1>AI-certified</1><2/> with ProfAI for Teams"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:37
msgid "Give us a few details to get started"
msgstr "Give us a few details to get started"

#: src/clients/signed-in/program-app/components/nps-survey/ExperienceStep.tsx:28
msgid "Good"
msgstr "Good"

#: src/clients/signed-in/program-app/tools/review.tsx:92
msgid "Great start - keep up the momentum"
msgstr "Great start - keep up the momentum"

#: src/clients/signed-in/program-app/tools/assessment.tsx:251
msgid "Great work!"
msgstr "Great work!"

#: src/clients/signed-in/program-app/tools/review.tsx:93
msgid "Halfway there!"
msgstr "Halfway there!"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:220
msgid "Healthcare"
msgstr "Healthcare"

#: src/clients/signed-in/program-app/tools/profile.tsx:71
msgid "Hey there!"
msgstr "Hey there!"

#: src/clients/signed-in/program-app/components/ExerciseHelp.tsx:118
msgid "HIDE HELP"
msgstr "HIDE HELP"

#: src/clients/signed-in/program-app/components/nps-survey/ConfidenceStep.tsx:42
msgid "How confident are you using AI at work after ProfAI?"
msgstr "How confident are you using AI at work after ProfAI?"

#: src/clients/signed-in/program-app/components/nps-survey/NpsStep.tsx:17
msgid "How likely are you to recommend ProfAI to a friend or colleague?"
msgstr "How likely are you to recommend ProfAI to a friend or colleague?"

#: src/clients/signed-in/program-app/components/nps-survey/ExperienceStep.tsx:41
msgid "How was your overall experience with ProfAI?"
msgstr "How was your overall experience with ProfAI?"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:207
msgid "Human Resources/People"
msgstr "Human Resources/People"

#: src/clients/signed-in/program-app/tools/assessment.tsx:122
msgid "I'm generating a quick assessment for you..."
msgstr "I'm generating a quick assessment for you..."

#: src/clients/signed-in/program-app/tools/assessment.tsx:209
msgid "I'm taking that in..."
msgstr "I'm taking that in..."

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:434
msgid "In the area"
msgstr "In the area"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:131
msgid "Industry"
msgstr "Industry"

#: src/clients/signed-in/program-app/components/ExerciseHelp.tsx:246
#: src/clients/signed-in/program-app/components/onboarding/Profile.tsx:57
msgid "Industry or company"
msgstr "Industry or company"

#: src/clients/signed-in/program-app/components/ExerciseHelp.tsx:325
msgid "Instructions were unclear"
msgstr "Instructions were unclear"

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:466
msgid "It begins with the text \"<0>{firstWord}</0>\""
msgstr "It begins with the text \"<0>{firstWord}</0>\""

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:108
msgid "Job Function"
msgstr "Job Function"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:62
msgid "Job Level"
msgstr "Job Level"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:52
#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:56
msgid "Job Title"
msgstr "Job Title"

#: src/clients/signed-in/program-app/tools/profile.tsx:129
msgid "Just a couple more questions..."
msgstr "Just a couple more questions..."

#: src/clients/signed-in/program-app/components/ProgramCompletion.tsx:115
msgid "Just one more to go before you can claim your badge!"
msgstr "Just one more to go before you can claim your badge!"

#: src/clients/signed-in/program-app/tools/assessment.tsx:265
msgid "Keep going"
msgstr "Keep going"

#: src/clients/signed-in/program-app/ProfilePage.tsx:136
msgid "Language"
msgstr "Language"

#: src/clients/signed-in/reporting-app/NpsReport.tsx:160
msgid "Last 3 days vs Previous 3 days"
msgstr "Last 3 days vs Previous 3 days"

#: src/clients/signed-in/reporting-app/NpsReport.tsx:164
msgid "Last 30 days vs Previous 30 days"
msgstr "Last 30 days vs Previous 30 days"

#: src/clients/signed-in/reporting-app/NpsReport.tsx:162
msgid "Last 7 days vs Previous 7 days"
msgstr "Last 7 days vs Previous 7 days"

#: src/clients/signed-in/reporting-app/NpsReport.tsx:166
msgid "Last 90 days vs Previous 90 days"
msgstr "Last 90 days vs Previous 90 days"

#: src/clients/signed-in/program-app/components/ExerciseHelp.tsx:233
#: src/clients/signed-in/program-app/components/BadgeDialog.tsx:95
#: src/clients/signed-in/program-app/components/onboarding/User.tsx:36
msgid "Last Name"
msgstr "Last Name"

#: src/clients/signed-in/program-app/components/BadgeDialog.tsx:102
msgid "Last name is required"
msgstr "Last name is required"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:209
msgid "Learning & Development"
msgstr "Learning & Development"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:210
msgid "Legal/Compliance"
msgstr "Legal/Compliance"

#: src/clients/signed-in/program-app/components/ExerciseHelp.tsx:300
msgid "Let us know so we can improve it."
msgstr "Let us know so we can improve it."

#: src/clients/signed-in/program-app/tools/assessment.tsx:117
msgid "Let's get started!"
msgstr "Let's get started!"

#: src/clients/signed-in/program-app/tools/exercise.tsx:91
#: src/clients/signed-in/program-app/tools/assessment.tsx:173
#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:316
msgid "Let's go!"
msgstr "Let's go!"

#: src/clients/signed-in/program-app/components/BadgeDialog.tsx:79
msgid "Let's personalize your badge! Please enter your full name."
msgstr "Let's personalize your badge! Please enter your full name."

#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:20
msgid ""
"Let’s start by introducing a couple of key prompt building blocks, the Task and the Context.\n"
"\n"
"Start by clicking the button below to reveal the Task."
msgstr ""
"Let’s start by introducing a couple of key prompt building blocks, the Task and the Context.\n"
"\n"
"Start by clicking the button below to reveal the Task."

#: src/clients/signed-in/program-app/tools/profile.tsx:80
msgid "Let's start easy. What's your first name?"
msgstr "Let's start easy. What's your first name?"

#: src/clients/signed-in/program-app/components/onboarding/User.tsx:19
msgid "Let's start with the basics."
msgstr "Let's start with the basics."

#: src/clients/signed-in/program-app/components/PromptTypesExercise.tsx:94
#: src/clients/signed-in/program-app/components/AiHallucinationPracticeExercise.tsx:99
msgid "Let's try another"
msgstr "Let's try another"

#: src/clients/signed-in/components/analytics-dashboard/UserEngagementChart.tsx:96
msgid "Loading chart..."
msgstr "Loading chart..."

#: src/clients/signed-in/reporting-app/NpsReport.tsx:223
msgid "Loading NPS data..."
msgstr "Loading NPS data..."

#: src/clients/signed-in/program-app/ProgramBySlug.tsx:152
msgid "Loading program data..."
msgstr "Loading program data..."

#: src/clients/signed-in/program-app/Home.tsx:11
msgid "Loading Prompting Fundamentals"
msgstr "Loading Prompting Fundamentals"

#: src/clients/signed-in/program-app/ProgramSkill.tsx:39
#: src/clients/signed-in/program-app/ProgramSkill.tsx:56
msgid "Loading skill content..."
msgstr "Loading skill content..."

#: src/clients/signed-in/program-app/tools/assessment.tsx:73
msgid "Loading skill..."
msgstr "Loading skill..."

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:181
msgid "Manager"
msgstr "Manager"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:221
msgid "Manufacturing"
msgstr "Manufacturing"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:202
msgid "Marketing/Advertising"
msgstr "Marketing/Advertising"

#: src/clients/signed-in/components/PromoDialog.tsx:103
msgid "Maybe Later"
msgstr "Maybe Later"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:535
msgid "MISSING"
msgstr "MISSING"

#: src/clients/signed-in/program-app/components/nps-survey/ConfidenceStep.tsx:24
msgid "Moderately confident"
msgstr "Moderately confident"

#: src/clients/signed-in/program-app/tools/review.tsx:68
msgid "Moving on to the next exercise..."
msgstr "Moving on to the next exercise..."

#: src/clients/signed-in/program-app/tools/review.tsx:203
msgid "Moving on to the next skill..."
msgstr "Moving on to the next skill..."

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:437
msgid "Nailed it!"
msgstr "Nailed it!"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:394
msgid "NAME"
msgstr "NAME"

#: src/clients/signed-in/reporting-app/NpsReport.tsx:158
#: src/clients/signed-in/reporting-app/NpsReport.tsx:168
msgid "Net Promoter Score and survey metrics"
msgstr "Net Promoter Score and survey metrics"

#: src/clients/signed-in/program-app/components/nps-survey/ExperienceStep.tsx:23
msgid "Neutral"
msgstr "Neutral"

#: src/clients/signed-in/program-app/tools/feedback.tsx:15
msgid "new skills"
msgstr "new skills"

#: src/clients/signed-in/program-app/components/StdFlowMessageAckExercise.tsx:81
#: src/clients/signed-in/program-app/components/PromptTypesContentExercise.tsx:68
#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:349
#: src/clients/signed-in/program-app/components/AiBiasPracticeExercise.tsx:131
#: src/clients/signed-in/program-app/components/AiBiasPracticeExercise.tsx:138
#: src/clients/signed-in/program-app/components/onboarding/Layout.tsx:72
msgid "Next"
msgstr "Next"

#: src/clients/signed-in/program-app/components/AiPrivacyExamplesExercise.tsx:82
msgid "Next Exercise"
msgstr "Next Exercise"

#: src/clients/signed-in/program-app/components/PromptTypesExercise.tsx:94
#: src/clients/signed-in/program-app/components/AiHallucinationPracticeExercise.tsx:99
msgid "Next one"
msgstr "Next one"

#: src/clients/signed-in/program-app/tools/results.tsx:106
msgid "Next Up"
msgstr "Next Up"

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:318
msgid "Next, you'll be asked to find <0>{submittingLabel}</0>"
msgstr "Next, you'll be asked to find <0>{submittingLabel}</0>"

#: src/clients/signed-in/program-app/tools/results.tsx:35
msgid "Nice work, {name}!"
msgstr "Nice work, {name}!"

#: src/clients/signed-in/program-app/components/nps-survey/UsageStep.tsx:13
msgid "No"
msgstr "No"

#: src/clients/signed-in/reporting-app/NpsReport.tsx:420
msgid "NO CHANGE"
msgstr "NO CHANGE"

#: src/clients/signed-in/reporting-app/NpsReport.tsx:238
msgid "No data available"
msgstr "No data available"

#: src/clients/signed-in/reporting-app/ProgressReport.tsx:95
msgid "No data to display"
msgstr "No data to display"

#: src/clients/signed-in/reporting-app/NpsReport.tsx:100
msgid "No NPS data available"
msgstr "No NPS data available"

#: src/clients/signed-in/reporting-app/NpsReport.tsx:109
msgid "No NPS data to display"
msgstr "No NPS data to display"

#: src/clients/signed-in/reporting-app/NpsReport.tsx:103
msgid "No NPS survey responses found for the selected scope."
msgstr "No NPS survey responses found for the selected scope."

#: src/clients/signed-in/program-app/components/nps-survey/ConfidenceStep.tsx:14
msgid "Not at all confident"
msgstr "Not at all confident"

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:432
msgid "Not even close"
msgstr "Not even close"

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:423
msgid "Now and click on the last word of {currentStepLabel}"
msgstr "Now and click on the last word of {currentStepLabel}"

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:261
msgid "Now it's your turn to find the building blocks in the example prompt below."
msgstr "Now it's your turn to find the building blocks in the example prompt below."

#: src/clients/signed-in/reporting-app/NpsReport.tsx:177
msgid "NPS Report"
msgstr "NPS Report"

#: src/clients/signed-in/reporting-app/NpsReport.tsx:248
msgid "NPS Score"
msgstr "NPS Score"

#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:306
msgid "Ok, Got it"
msgstr "Ok, Got it"

#: src/clients/signed-in/components/analytics-dashboard/UserEngagementChart.tsx:20
msgid "Onboarded"
msgstr "Onboarded"

#: src/clients/signed-in/program-app/tools/profile.tsx:178
msgid "One last question..."
msgstr "One last question..."

#: src/clients/signed-in/program-app/tools/assessment.tsx:117
msgid "One moment please"
msgstr "One moment please"

#: src/clients/signed-in/program-app/tools/review.tsx:94
msgid "One more push"
msgstr "One more push"

#: src/clients/signed-in/program-app/components/AIAcademyLink.tsx:19
msgid "Open AI Academy"
msgstr "Open AI Academy"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:205
msgid "Operations/Supply Chain"
msgstr "Operations/Supply Chain"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:188
#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:213
#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:225
msgid "Other"
msgstr "Other"

#: src/clients/signed-in/components/PanicBanner.tsx:11
msgid "Our AI helpers are doing some quick maintenance. ProfAI will be back shortly."
msgstr "Our AI helpers are doing some quick maintenance. ProfAI will be back shortly."

#: src/clients/signed-in/program-app/tools/planning.tsx:148
msgid "Our servers are currently experiencing high demand. Your exercise is still being prepared."
msgstr "Our servers are currently experiencing high demand. Your exercise is still being prepared."

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:533
msgid "PARTIAL"
msgstr "PARTIAL"

#: src/clients/signed-in/reporting-app/NpsReport.tsx:285
msgid "Plan to Use"
msgstr "Plan to Use"

#: src/clients/signed-in/program-app/components/onboarding/Profile.tsx:133
#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:160
msgid "Please enter your details."
msgstr "Please enter your details."

#: src/clients/signed-in/program-app/components/onboarding/User.tsx:56
msgid "Please enter your first and last name"
msgstr "Please enter your first and last name"

#: src/clients/signed-in/components/NewVersionAvailable.tsx:27
msgid "Please refresh the page to apply the changes and continue."
msgstr "Please refresh the page to apply the changes and continue."

#: src/clients/signed-in/reporting-app/ProgressReport.tsx:31
#: src/clients/signed-in/reporting-app/NpsReport.tsx:55
msgid "Please try refreshing the page"
msgstr "Please try refreshing the page"

#: src/clients/signed-in/program-app/components/nps-survey/ExperienceStep.tsx:18
msgid "Poor"
msgstr "Poor"

#: src/clients/signed-in/program-app/components/CompetencyExercises.tsx:203
msgid "Practice"
msgstr "Practice"

#: src/clients/signed-in/program-app/tools/feedback.tsx:19
msgid "proceed"
msgstr "proceed"

#: src/clients/signed-in/program-app/components/PromptMadLibExercise.tsx:154
msgid "Processing..."
msgstr "Processing..."

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:206
msgid "Product Management"
msgstr "Product Management"

#: src/clients/signed-in/components/TutorAvatar.tsx:39
msgid "Prof<0>AI</0>"
msgstr "Prof<0>AI</0>"

#: src/clients/signed-in/platform-app/components/ProfAIAvatar.tsx:12
#: src/clients/signed-in/components/TutorAvatar.tsx:21
msgid "ProfAI Avatar"
msgstr "ProfAI Avatar"

#: src/clients/signed-in/components/PromoBanner.tsx:27
msgid "ProfAI for Teams ›"
msgstr "ProfAI for Teams ›"

#: src/clients/signed-in/components/Disclaimer.tsx:7
msgid "ProfAI uses AI to generate learning exercises. Content and exercises may contain occasional inaccuracies."
msgstr "ProfAI uses AI to generate learning exercises. Content and exercises may contain occasional inaccuracies."

#: src/clients/signed-in/program-app/components/ProgressTracker.tsx:260
msgid "Program Badge"
msgstr "Program Badge"

#: src/clients/signed-in/components/analytics-dashboard/UserEngagementChart.tsx:32
msgid "Program Completed"
msgstr "Program Completed"

#: src/clients/signed-in/program-app/ProgramBySlug.tsx:73
msgid "Program data failed to load"
msgstr "Program data failed to load"

#: src/clients/signed-in/reporting-app/ProgressReport.tsx:110
msgid "Program Overview"
msgstr "Program Overview"

#: src/clients/signed-in/components/analytics-dashboard/UserEngagementChart.tsx:26
msgid "Program Started"
msgstr "Program Started"

#: src/clients/signed-in/components/analytics-dashboard/MetricsGrid.tsx:31
msgid "Programs Completed"
msgstr "Programs Completed"

#: src/clients/signed-in/reporting-app/ProgressReport.tsx:18
#: src/clients/signed-in/reporting-app/ProgressReport.tsx:82
#: src/clients/signed-in/components/UserAvatarMenu.tsx:17
msgid "Progress Dashboard"
msgstr "Progress Dashboard"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:227
#: src/clients/signed-in/program-app/components/PromptMadLibExercise.tsx:128
#: src/clients/signed-in/program-app/components/AiPrivacyExamplesExercise.tsx:113
msgid "prompt"
msgstr "prompt"

#: src/clients/signed-in/program-app/tools/assessment.tsx:149
msgid "PROMPT"
msgstr "PROMPT"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:331
msgid "Prompt Scorecard"
msgstr "Prompt Scorecard"

#: src/clients/signed-in/program-app/components/AiUseCasePromptBuilderExercise.tsx:198
msgid "Prompt template"
msgstr "Prompt template"

#: src/clients/signed-in/components/analytics-dashboard/UserEngagementChart.tsx:162
msgid "Raw Count"
msgstr "Raw Count"

#: src/clients/signed-in/program-app/tools/assessment.tsx:121
msgid "Ready to write a helpful prompt?"
msgstr "Ready to write a helpful prompt?"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:439
#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:136
#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:142
#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:196
#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:202
#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:218
msgid "Reasoning"
msgstr "Reasoning"

#: src/clients/signed-in/program-app/tools/overview.tsx:188
msgid "Recommended"
msgstr "Recommended"

#: src/clients/signed-in/program-app/components/Onboarding.tsx:65
msgid "Recording onboarding..."
msgstr "Recording onboarding..."

#: src/clients/signed-in/program-app/components/AiUseCasePromptBuilderExercise.tsx:166
msgid "Refine my idea"
msgstr "Refine my idea"

#: src/clients/signed-in/program-app/components/ExerciseHelp.tsx:82
msgid "Report Exercise"
msgstr "Report Exercise"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:432
#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:134
#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:140
#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:194
#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:200
#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:214
msgid "Requirements"
msgstr "Requirements"

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:70
msgid "Requirements specify the criteria or constraints that must be met. Look for specific details about what the solution must include or achieve."
msgstr "Requirements specify the criteria or constraints that must be met. Look for specific details about what the solution must include or achieve."

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:222
msgid "Retail"
msgstr "Retail"

#: src/clients/signed-in/program-app/components/AiPrivacyExamplesExercise.tsx:54
msgid "Reveal More Sensitive Info"
msgstr "Reveal More Sensitive Info"

#: src/clients/signed-in/program-app/components/AiPrivacyExamplesExercise.tsx:26
msgid "Reveal Sensitive Info"
msgstr "Reveal Sensitive Info"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:415
#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:133
#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:139
#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:193
#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:199
#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:208
msgid "Role"
msgstr "Role"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:211
msgid "Sales/Revenue"
msgstr "Sales/Revenue"

#: src/clients/signed-in/program-app/ProfilePage.tsx:156
#: src/clients/signed-in/program-app/components/ExerciseHelp.tsx:277
msgid "Save"
msgstr "Save"

#: src/clients/signed-in/program-app/components/AiUseCasePromptBuilderExercise.tsx:305
msgid "Save & back to skill"
msgstr "Save & back to skill"

#: src/clients/signed-in/program-app/components/AiUseCasePromptBuilderExercise.tsx:306
msgid "Save & Continue"
msgstr "Save & Continue"

#: src/clients/signed-in/program-app/components/AiUseCasePromptBuilderExercise.tsx:303
msgid "Saving..."
msgstr "Saving..."

#: src/clients/signed-in/program-app/components/PromptTypesExercise.tsx:59
msgid "Scenario"
msgstr "Scenario"

#: src/clients/signed-in/program-app/components/PromptTypesContentExercise.tsx:60
msgid "SCENARIO"
msgstr "SCENARIO"

#: src/clients/signed-in/program-app/tools/assessment.tsx:132
msgid "Scenario:"
msgstr "Scenario:"

#: src/clients/signed-in/components/analytics-dashboard/DashboardHeader.tsx:57
msgid "Select a customer to view their data"
msgstr "Select a customer to view their data"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:93
msgid "Select company size"
msgstr "Select company size"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:139
msgid "Select industry"
msgstr "Select industry"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:116
msgid "Select job function"
msgstr "Select job function"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:70
msgid "Select job level"
msgstr "Select job level"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:187
msgid "Self-employed"
msgstr "Self-employed"

#: src/clients/signed-in/program-app/components/AiUseCasePromptBuilderExercise.tsx:138
msgid "Share your idea..."
msgstr "Share your idea..."

#: src/clients/signed-in/program-app/components/onboarding/Profile.tsx:83
msgid "Shorten your company description to a few sentences."
msgstr "Shorten your company description to a few sentences."

#: src/clients/signed-in/program-app/components/onboarding/Profile.tsx:116
msgid "Shorten your role description to a few sentences."
msgstr "Shorten your role description to a few sentences."

#: src/clients/signed-in/program-app/components/ExerciseHelp.tsx:123
msgid "SHOW HELP"
msgstr "SHOW HELP"

#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:306
msgid "Show the {breakdownNextStep}"
msgstr "Show the {breakdownNextStep}"

#: src/clients/signed-in/program-app/ProfilePage.tsx:173
msgid "Sign out"
msgstr "Sign out"

#: src/clients/signed-in/program-app/tools/overview.tsx:84
msgid "Skip ahead by taking a short assessment."
msgstr "Skip ahead by taking a short assessment."

#: src/clients/signed-in/program-app/components/nps-survey/ConfidenceStep.tsx:19
msgid "Slightly confident"
msgstr "Slightly confident"

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:436
msgid "So close"
msgstr "So close"

#: src/clients/signed-in/program-app/ProgramBySlug.tsx:217
#: src/clients/signed-in/program-app/components/StartScreen.tsx:23
msgid "Start"
msgstr "Start"

#: src/clients/signed-in/program-app/tools/overview.tsx:72
#: src/clients/signed-in/program-app/tools/overview.tsx:74
msgid "Start the Skill"
msgstr "Start the Skill"

#: src/clients/signed-in/program-app/components/ProgramCompletion.tsx:109
msgid "Start your journey to earn a badge!"
msgstr "Start your journey to earn a badge!"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:399
msgid "STATUS"
msgstr "STATUS"

#: src/clients/signed-in/program-app/tools/profile.tsx:97
#: src/clients/signed-in/program-app/tools/profile.tsx:150
#: src/clients/signed-in/program-app/tools/profile.tsx:199
#: src/clients/signed-in/program-app/components/Quiz.tsx:35
#: src/clients/signed-in/program-app/components/PromptMadLibExercise.tsx:161
#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:365
#: src/clients/signed-in/program-app/components/ExerciseHelp.tsx:349
#: src/clients/signed-in/program-app/components/AiPrivacyPracticeExercise.tsx:48
#: src/clients/signed-in/program-app/components/onboarding/Profile.tsx:134
msgid "Submit"
msgstr "Submit"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:531
msgid "SUCCESS"
msgstr "SUCCESS"

#: src/clients/signed-in/program-app/components/onboarding/Profile.tsx:71
#: src/clients/signed-in/program-app/components/onboarding/Profile.tsx:104
msgid "Suggest"
msgstr "Suggest"

#: src/clients/signed-in/program-app/tools/overview.tsx:83
#: src/clients/signed-in/program-app/tools/overview.tsx:85
msgid "Take the Assessment"
msgstr "Take the Assessment"

#: src/clients/signed-in/components/PromoDialog.tsx:95
msgid "Talk to Sales ›"
msgstr "Talk to Sales ›"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:420
#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:131
#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:137
#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:191
#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:197
#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:210
msgid "Task"
msgstr "Task"

#: src/clients/signed-in/components/PromoDialog.tsx:74
msgid "Team access for 50+ people"
msgstr "Team access for 50+ people"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:223
msgid "Technology"
msgstr "Technology"

#: src/clients/signed-in/program-app/tools/profile.tsx:181
msgid "Tell me a bit about your role and responsibilities. The more detail you share, the better I'll be able to create exercises relevant to your work."
msgstr "Tell me a bit about your role and responsibilities. The more detail you share, the better I'll be able to create exercises relevant to your work."

#: src/clients/signed-in/program-app/components/onboarding/Profile.tsx:45
msgid "Tell us a bit about your work."
msgstr "Tell us a bit about your work."

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:34
msgid "Tell us about yourself"
msgstr "Tell us about yourself"

#: src/clients/signed-in/program-app/components/AiUseCasePromptBuilderExercise.tsx:237
msgid "Test my prompt"
msgstr "Test my prompt"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:305
msgid "Test prompt"
msgstr "Test prompt"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:300
msgid "Testing..."
msgstr "Testing..."

#: src/clients/signed-in/program-app/components/Clicklighter.tsx:309
msgid "Text highlighter"
msgstr "Text highlighter"

#: src/clients/signed-in/program-app/tools/planning.tsx:143
msgid "Thank you for your patience. This is taking a bit longer than expected."
msgstr "Thank you for your patience. This is taking a bit longer than expected."

#: src/clients/signed-in/program-app/tools/assessment.tsx:253
msgid "Thanks for giving me an idea of where you're at. I'll try to ensure that the exercises are aligned with your skill level."
msgstr "Thanks for giving me an idea of where you're at. I'll try to ensure that the exercises are aligned with your skill level."

#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:23
#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:63
#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:117
msgid "That's all you need to know to do well on the following exercises. Ready to dive in?"
msgstr "That's all you need to know to do well on the following exercises. Ready to dive in?"

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:226
msgid "the Boundaries"
msgstr "the Boundaries"

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:222
msgid "the Context"
msgstr "the Context"

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:69
msgid "The context provides the situation or purpose for the task. It often starts with 'for', 'to', or 'in order to' and explains why the task is needed."
msgstr "The context provides the situation or purpose for the task. It often starts with 'for', 'to', or 'in order to' and explains why the task is needed."

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:428
msgid "The correct answer is in there, try fewer words."
msgstr "The correct answer is in there, try fewer words."

#: src/clients/signed-in/program-app/components/PromptTypesContentExercise.tsx:41
msgid "The following scenario is best suited for a {showingLabel} prompt."
msgstr "The following scenario is best suited for a {showingLabel} prompt."

#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:61
msgid ""
"The highlighted text is the Role, a description of the identity or perspective in the prompt. This helps frame your request and gives the AI important background about your needs.\n"
"\n"
""
msgstr ""
"The highlighted text is the Role, a description of the identity or perspective in the prompt. This helps frame your request and gives the AI important background about your needs.\n"
"\n"
""

#: src/clients/signed-in/program-app/ProfilePage.tsx:93
msgid "The information you provide about your company and role will be used to create a personalized and familiar lesson plan."
msgstr "The information you provide about your company and role will be used to create a personalized and familiar lesson plan."

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:228
msgid "the Reasoning"
msgstr "the Reasoning"

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:72
msgid "The reasoning explains why the task is important or what outcomes are expected. Look for explanations of impact or justification for the work."
msgstr "The reasoning explains why the task is important or what outcomes are expected. Look for explanations of impact or justification for the work."

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:224
msgid "the Requirements"
msgstr "the Requirements"

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:218
msgid "the Role"
msgstr "the Role"

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:67
msgid "The role is typically introduced with 'As a' or 'As the' and describes who is performing the task. Look for a job title or position that would be responsible for this work."
msgstr "The role is typically introduced with 'As a' or 'As the' and describes who is performing the task. Look for a job title or position that would be responsible for this work."

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:220
msgid "the Task"
msgstr "the Task"

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:68
msgid "The task description is the specific action or deliverable that needs to be completed. Look for action verbs like 'create', 'develop', 'analyze', or 'design'."
msgstr "The task description is the specific action or deliverable that needs to be completed. Look for action verbs like 'create', 'develop', 'analyze', or 'design'."

#: src/clients/signed-in/reporting-app/ProgressReport.tsx:98
msgid "There is no analytics data to show yet."
msgstr "There is no analytics data to show yet."

#: src/clients/signed-in/reporting-app/NpsReport.tsx:112
msgid "There is no NPS survey data to show yet."
msgstr "There is no NPS survey data to show yet."

#: src/clients/signed-in/program-app/tools/planning.tsx:104
msgid "There was a problem creating your exercise."
msgstr "There was a problem creating your exercise."

#: src/clients/signed-in/program-app/tools/exercise.tsx:161
msgid "There was an error loading the exercise."
msgstr "There was an error loading the exercise."

#: src/clients/signed-in/program-app/tools/exercise.tsx:163
msgid "There was an unexpected error."
msgstr "There was an unexpected error."

#: src/clients/signed-in/program-app/tools/exercise.tsx:164
msgid "There was problem creating the exercise."
msgstr "There was problem creating the exercise."

#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:115
msgid "These are the Boundaries, the limits or constraints of the task. Look for phrases that specify what should be maintained, avoided, or kept within certain parameters."
msgstr "These are the Boundaries, the limits or constraints of the task. Look for phrases that specify what should be maintained, avoided, or kept within certain parameters."

#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:62
msgid "These are the Requirements, the specific criteria or constraints that must be met. Clear and specific requirements help you get precise outputs from an AI assistant instead of vague responses."
msgstr "These are the Requirements, the specific criteria or constraints that must be met. Clear and specific requirements help you get precise outputs from an AI assistant instead of vague responses."

#: src/clients/signed-in/program-app/components/AiPrivacyExamplesExercise.tsx:67
msgid "This area also contains sensitive information."
msgstr "This area also contains sensitive information."

#: src/clients/signed-in/program-app/components/AiPrivacyExamplesExercise.tsx:39
msgid "This area contains sensitive information. Let's address that."
msgstr "This area contains sensitive information. Let's address that."

#: src/clients/signed-in/program-app/components/ExerciseHelp.tsx:142
msgid "This exercise has no hints."
msgstr "This exercise has no hints."

#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:21
msgid ""
"This highlighted text is the Task. It's the core instruction you'll give to an AI assistant. A good task is clear, specific, and action-oriented.\n"
"\n"
""
msgstr ""
"This highlighted text is the Task. It's the core instruction you'll give to an AI assistant. A good task is clear, specific, and action-oriented.\n"
"\n"
""

#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:22
msgid ""
"This is the Context, a reasonable amount of background information the AI will need to know to perform well on the task.\n"
"\n"
""
msgstr ""
"This is the Context, a reasonable amount of background information the AI will need to know to perform well on the task.\n"
"\n"
""

#: src/clients/signed-in/program-app/components/PromptBreakdownExercise.tsx:116
msgid "This is the Reasoning, the explanation of why the task is important or what outcomes are expected. Look for explanations of impact or justification for the work."
msgstr "This is the Reasoning, the explanation of why the task is important or what outcomes are expected. Look for explanations of impact or justification for the work."

#: src/clients/signed-in/program-app/components/onboarding/Language.tsx:29
msgid "This will help us personalize your experience."
msgstr "This will help us personalize your experience."

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:197
msgid "Time to write your own prompt from scratch. Here's the scenario:"
msgstr "Time to write your own prompt from scratch. Here's the scenario:"

#: src/clients/signed-in/program-app/components/ExerciseHelp.tsx:336
msgid "Too hard or time-consuming"
msgstr "Too hard or time-consuming"

#: src/clients/signed-in/components/analytics-dashboard/UserEngagementChart.tsx:22
msgid "Total number of users who have completed account onboarding"
msgstr "Total number of users who have completed account onboarding"

#: src/clients/signed-in/components/analytics-dashboard/UserEngagementChart.tsx:34
msgid "Total number of users who have completed the program and earned a certification"
msgstr "Total number of users who have completed the program and earned a certification"

#: src/clients/signed-in/components/analytics-dashboard/UserEngagementChart.tsx:16
msgid "Total number of users who have created accounts in the platform"
msgstr "Total number of users who have created accounts in the platform"

#: src/clients/signed-in/components/analytics-dashboard/UserEngagementChart.tsx:28
msgid "Total number of users who have started the program"
msgstr "Total number of users who have started the program"

#: src/clients/signed-in/reporting-app/NpsReport.tsx:252
msgid "Total Responses"
msgstr "Total Responses"

#: src/clients/signed-in/components/analytics-dashboard/MetricsGrid.tsx:23
msgid "Total Users"
msgstr "Total Users"

#: src/clients/signed-in/reporting-app/ProgressReport.tsx:85
msgid "Track user engagement and progress toward AI proficiency in ProfAI"
msgstr "Track user engagement and progress toward AI proficiency in ProfAI"

#: src/clients/signed-in/program-app/components/onboarding/Demographics.tsx:224
msgid "Transportation"
msgstr "Transportation"

#: src/clients/signed-in/program-app/tools/exercise.tsx:179
#: src/clients/signed-in/program-app/components/PromptMadLibExercise.tsx:160
#: src/clients/signed-in/program-app/components/AiPrivacyPracticeExercise.tsx:47
msgid "Try again"
msgstr "Try again"

#: src/clients/signed-in/program-app/tools/planning.tsx:108
#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:303
#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:360
msgid "Try Again"
msgstr "Try Again"

#: src/clients/signed-in/program-app/components/AiUseCasePromptBuilderExercise.tsx:107
msgid "Try out your prompt below by typing or pasting text into the highlighted fields."
msgstr "Try out your prompt below by typing or pasting text into the highlighted fields."

#: src/clients/signed-in/program-app/tools/review.tsx:143
msgid "Up next:"
msgstr "Up next:"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:339
msgid "Update your prompt with the following changes and try again."
msgstr "Update your prompt with the following changes and try again."

#: src/clients/signed-in/program-app/components/Onboarding.tsx:33
msgid "Updating your personalization information..."
msgstr "Updating your personalization information..."

#: src/clients/signed-in/reporting-app/ProgressReport.tsx:113
msgid "User progress against key program milestones"
msgstr "User progress against key program milestones"

#: src/clients/signed-in/components/analytics-dashboard/UserEngagementChart.tsx:40
msgid "Users who have requested their earned badge"
msgstr "Users who have requested their earned badge"

#: src/clients/signed-in/program-app/components/nps-survey/ConfidenceStep.tsx:29
msgid "Very confident"
msgstr "Very confident"

#: src/clients/signed-in/program-app/components/nps-survey/ExperienceStep.tsx:13
msgid "Very poor"
msgstr "Very poor"

#: src/clients/signed-in/components/analytics-dashboard/DashboardHeader.tsx:42
msgid "View dashboard as customer. (Refresh the page to reset)"
msgstr "View dashboard as customer. (Refresh the page to reset)"

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:430
msgid "Waiting for a Highlight"
msgstr "Waiting for a Highlight"

#: src/clients/signed-in/program-app/components/ExerciseHelp.tsx:297
msgid "Was there something wrong with this exercise?"
msgstr "Was there something wrong with this exercise?"

#: src/clients/signed-in/program-app/components/ExerciseHelp.tsx:314
msgid "Wasn't relevant to my role/job"
msgstr "Wasn't relevant to my role/job"

#: src/clients/signed-in/program-app/tools/planning.tsx:144
msgid "We appreciate your patience. Your custom exercise requires additional processing time."
msgstr "We appreciate your patience. Your custom exercise requires additional processing time."

#: src/clients/signed-in/program-app/components/onboarding/Profile.tsx:48
msgid "We'll use this information to customize every exercise to your specific situation. You can change it at any time."
msgstr "We'll use this information to customize every exercise to your specific situation. You can change it at any time."

#: src/clients/signed-in/program-app/tools/planning.tsx:149
msgid "We're experiencing peak usage right now. Your custom exercise is still in the queue."
msgstr "We're experiencing peak usage right now. Your custom exercise is still in the queue."

#: src/clients/signed-in/program-app/tools/overview.tsx:45
msgid "Welcome to {skillTitle}, {name}"
msgstr "Welcome to {skillTitle}, {name}"

#: src/clients/signed-in/program-app/tools/overview.tsx:106
msgid "Welcome to {skillTitle}, {name}!"
msgstr "Welcome to {skillTitle}, {name}!"

#: src/clients/signed-in/program-app/components/onboarding/Introduction.tsx:39
msgid "Welcome to ProfAI"
msgstr "Welcome to ProfAI"

#: src/clients/signed-in/program-app/tools/profile.tsx:126
msgid "Well, it's nice to meet you, {name}!"
msgstr "Well, it's nice to meet you, {name}!"

#: src/clients/signed-in/program-app/tools/profile.tsx:132
msgid "What company do you work at and what do they do? The more information you provide, the more I can customize this experience to you."
msgstr "What company do you work at and what do they do? The more information you provide, the more I can customize this experience to you."

#: src/clients/signed-in/program-app/components/AiHallucinationPracticeExercise.tsx:61
msgid "What is causing the hallucination in the following AI generated output?"
msgstr "What is causing the hallucination in the following AI generated output?"

#: src/clients/signed-in/program-app/components/onboarding/User.tsx:22
msgid "What should I call you?"
msgstr "What should I call you?"

#: src/clients/signed-in/program-app/components/nps-survey/NpsStep.tsx:47
msgid "What's the main reason for your score above?"
msgstr "What's the main reason for your score above?"

#: src/clients/signed-in/program-app/components/nps-survey/UsageStep.tsx:21
msgid "Will you apply what you learned in ProfAI over the next 30 days?"
msgstr "Will you apply what you learned in ProfAI over the next 30 days?"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:230
msgid "Write a {type} to help you with this scenario."
msgstr "Write a {type} to help you with this scenario."

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:204
msgid "Write a <0>{promptType}</0> to help you accomplish this."
msgstr "Write a <0>{promptType}</0> to help you accomplish this."

#: src/clients/signed-in/program-app/components/PromptMadLibExercise.tsx:123
msgid "Write a prompt to help you with the scenario above. To create the prompt, fill in each building block before submitting."
msgstr "Write a prompt to help you with the scenario above. To create the prompt, fill in each building block before submitting."

#: src/clients/signed-in/program-app/tools/assessment.tsx:162
msgid "Write your prompt here... don't worry, just try!"
msgstr "Write your prompt here... don't worry, just try!"

#: src/clients/signed-in/program-app/components/nps-survey/UsageStep.tsx:9
msgid "Yes"
msgstr "Yes"

#: src/clients/signed-in/program-app/tools/results.tsx:36
msgid "You are proficient at {skillTitle}."
msgstr "You are proficient at {skillTitle}."

#: src/clients/signed-in/program-app/tools/results.tsx:103
msgid "You are ready for your badge!"
msgstr "You are ready for your badge!"

#: src/clients/signed-in/program-app/components/ProgramCompletion.tsx:113
msgid "You are ready to claim your badge!"
msgstr "You are ready to claim your badge!"

#: src/clients/signed-in/program-app/components/onboarding/User.tsx:45
msgid "You can change this at any time."
msgstr "You can change this at any time."

#: src/clients/signed-in/program-app/components/ProgramBadge.tsx:45
msgid "You can now click your badge to view and share it with the world! Check {email} for more details."
msgstr "You can now click your badge to view and share it with the world! Check {email} for more details."

#: src/clients/signed-in/program-app/components/TestRunResults.tsx:9
msgid "You have reached the end of the test run, thank you."
msgstr "You have reached the end of the test run, thank you."

#: src/clients/signed-in/program-app/components/nps-survey/ExtendedNpsSurveyDialog.tsx:188
msgid "You'll receive a badge after completing this survey."
msgstr "You'll receive a badge after completing this survey."

#: src/clients/signed-in/program-app/tools/review.tsx:122
msgid "You're now <0>{competencyLevel}%</0> through <1>{skillTitle}</1>."
msgstr "You're now <0>{competencyLevel}%</0> through <1>{skillTitle}</1>."

#: src/clients/signed-in/program-app/components/PromptHighlightingExercise.tsx:314
msgid "You've got it, nicely done!"
msgstr "You've got it, nicely done!"

#: src/clients/signed-in/program-app/components/PromptWritingExercise.tsx:345
msgid "You've got it."
msgstr "You've got it."

#: src/clients/signed-in/program-app/components/CompetencyExercises.tsx:80
msgid "Your {customerName} AI Policy"
msgstr "Your {customerName} AI Policy"

#: src/clients/signed-in/program-app/tools/competencies.tsx:63
msgid "Your {skillTitle} Coaching Plan"
msgstr "Your {skillTitle} Coaching Plan"

#: src/clients/signed-in/program-app/components/ProgramCompletion.tsx:111
msgid "Your badge is on its way!"
msgstr "Your badge is on its way!"

#: src/clients/signed-in/program-app/ProfilePage.tsx:114
msgid "Your Company & Industry"
msgstr "Your Company & Industry"

#: src/clients/signed-in/program-app/components/AiUseCasePromptBuilderExercise.tsx:136
msgid "Your idea"
msgstr "Your idea"

#: src/clients/signed-in/program-app/ProfilePage.tsx:161
msgid "Your information has been updated."
msgstr "Your information has been updated."

#: src/clients/signed-in/program-app/components/nps-survey/NpsStep.tsx:50
msgid "Your most important reason..."
msgstr "Your most important reason..."

#: src/clients/signed-in/program-app/ProfilePage.tsx:102
msgid "Your Name"
msgstr "Your Name"

#: src/clients/signed-in/program-app/components/onboarding/Introduction.tsx:42
msgid "Your personal AI coach."
msgstr "Your personal AI coach."

#: src/clients/signed-in/program-app/ProfilePage.tsx:90
msgid "Your Profile"
msgstr "Your Profile"

#: src/clients/signed-in/program-app/Programs.tsx:8
msgid "Your Programs"
msgstr "Your Programs"

#: src/clients/signed-in/program-app/tools/assessment.tsx:164
msgid "Your response"
msgstr "Your response"

#: src/clients/signed-in/program-app/ProfilePage.tsx:125
msgid "Your Role and Responsibilities"
msgstr "Your Role and Responsibilities"

#: src/clients/signed-in/program-app/components/ExerciseHelp.tsx:259
#: src/clients/signed-in/program-app/components/onboarding/Profile.tsx:90
msgid "Your role or responsibilities"
msgstr "Your role or responsibilities"

#: src/clients/signed-in/program-app/tools/planning.tsx:139
msgid "Your tailored exercise is being prepared."
msgstr "Your tailored exercise is being prepared."
